export default __webpack_public_path__ + "static/media/Payroll-5.665ea93a.png";